import { GlobalState } from "./state";

// a reducer from another module
export const authSelector = (state: GlobalState) => state.auth.user;

// a reducer from this module

// other selectors....
